import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Support Needs by Department',
      type: 'table',
      alias: 'support-needs-all-departments-baseline',
      content: {
        '{}': {
          count: 6,
          query: {
            '`': {
              sort: {
                by: {
                  '@.': '!code',
                },
              },
              filter: {
                or: [
                  {
                    '=': [
                      {
                        '@.': '!name',
                      },
                      'Avery Caldwell',
                    ],
                  },
                  {
                    '=': [
                      {
                        '@.': '!name',
                      },
                      'Finley Rhodes',
                    ],
                  },
                  {
                    '=': [
                      {
                        '@.': '!name',
                      },
                      'Harper Collins',
                    ],
                  },
                  {
                    '=': [
                      {
                        '@.': '!name',
                      },
                      'Rowan Ellis',
                    ],
                  },
                  {
                    '=': [
                      {
                        '@.': '!name',
                      },
                      'Sage Mitchell',
                    ],
                  },
                  {
                    '=': [
                      {
                        '@.': '!name',
                      },
                      'Dakota Hayes',
                    ],
                  },
                ],
              },
              target: 'ent:!stakeholders:!stakeholder',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      needsReview: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Avery Caldwell',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Finley Rhodes',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Harper Collins',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Rowan Ellis',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Sage Mitchell',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Dakota Hayes',
                                  ],
                                },
                                0,
                              ],
                              null,
                            ],
                          },
                        },
                      },
                      dataReporting: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Avery Caldwell',
                                  ],
                                },
                                3,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Finley Rhodes',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Harper Collins',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Rowan Ellis',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Sage Mitchell',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Dakota Hayes',
                                  ],
                                },
                                0,
                              ],
                              null,
                            ],
                          },
                        },
                      },
                      designPlanning: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Avery Caldwell',
                                  ],
                                },
                                5,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Finley Rhodes',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Harper Collins',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Rowan Ellis',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Sage Mitchell',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Dakota Hayes',
                                  ],
                                },
                                0,
                              ],
                              null,
                            ],
                          },
                        },
                      },
                      trainingJobAids: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Avery Caldwell',
                                  ],
                                },
                                10,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Finley Rhodes',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Harper Collins',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Rowan Ellis',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Sage Mitchell',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Dakota Hayes',
                                  ],
                                },
                                1,
                              ],
                              null,
                            ],
                          },
                        },
                      },
                      changeTransition: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Avery Caldwell',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Finley Rhodes',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Harper Collins',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Rowan Ellis',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Sage Mitchell',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Dakota Hayes',
                                  ],
                                },
                                0,
                              ],
                              null,
                            ],
                          },
                        },
                      },
                      testingValidation: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Avery Caldwell',
                                  ],
                                },
                                4,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Finley Rhodes',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Harper Collins',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Rowan Ellis',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Sage Mitchell',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Dakota Hayes',
                                  ],
                                },
                                0,
                              ],
                              null,
                            ],
                          },
                        },
                      },
                      departmentFunction: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Avery Caldwell',
                                  ],
                                },
                                'Advancement',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Finley Rhodes',
                                  ],
                                },
                                'Information Technology',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Harper Collins',
                                  ],
                                },
                                'Finance and Treasury',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Rowan Ellis',
                                  ],
                                },
                                'Athletics',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Sage Mitchell',
                                  ],
                                },
                                'Undergraduate Financial Aid',
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Dakota Hayes',
                                  ],
                                },
                                'School of Engineering and Applied Science',
                              ],
                              null,
                            ],
                          },
                        },
                      },
                      leadershipDecision: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Avery Caldwell',
                                  ],
                                },
                                5,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Finley Rhodes',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Harper Collins',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Rowan Ellis',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Sage Mitchell',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Dakota Hayes',
                                  ],
                                },
                                0,
                              ],
                              null,
                            ],
                          },
                        },
                      },
                      processDocumentation: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Avery Caldwell',
                                  ],
                                },
                                5,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Finley Rhodes',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Harper Collins',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Rowan Ellis',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Sage Mitchell',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Dakota Hayes',
                                  ],
                                },
                                0,
                              ],
                              null,
                            ],
                          },
                        },
                      },
                      demonstrationsPractice: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Avery Caldwell',
                                  ],
                                },
                                7,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Finley Rhodes',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Harper Collins',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Rowan Ellis',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Sage Mitchell',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Dakota Hayes',
                                  ],
                                },
                                0,
                              ],
                              null,
                            ],
                          },
                        },
                      },
                      departmentStakeholders: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Avery Caldwell',
                                  ],
                                },
                                15,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Finley Rhodes',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Harper Collins',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Rowan Ellis',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Sage Mitchell',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Dakota Hayes',
                                  ],
                                },
                                1,
                              ],
                              null,
                            ],
                          },
                        },
                      },
                      communicationsReadiness: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Avery Caldwell',
                                  ],
                                },
                                3,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Finley Rhodes',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Harper Collins',
                                  ],
                                },
                                0,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Rowan Ellis',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Sage Mitchell',
                                  ],
                                },
                                1,
                              ],
                              [
                                {
                                  '=': [
                                    {
                                      '@.': '!name',
                                    },
                                    'Dakota Hayes',
                                  ],
                                },
                                1,
                              ],
                              null,
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'departmentFunction',
                  direct: {
                    '{}': {
                      name: 'Department / Function',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'departmentStakeholders',
                  direct: {
                    '{}': {
                      name: 'Stakeholders in Department',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'leadershipDecision',
                  direct: {
                    '{}': {
                      name: 'Leadership / Decision',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'communicationsReadiness',
                  direct: {
                    '{}': {
                      name: 'Communications / Readiness',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'demonstrationsPractice',
                  direct: {
                    '{}': {
                      name: 'Demonstrations / Practice',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'trainingJobAids',
                  direct: {
                    '{}': {
                      name: 'Training / Job Aids',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'processDocumentation',
                  direct: {
                    '{}': {
                      name: 'Process / Documentation',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'designPlanning',
                  direct: {
                    '{}': {
                      name: 'Design / Planning',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'testingValidation',
                  direct: {
                    '{}': {
                      name: 'Testing / Validation',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'dataReporting',
                  direct: {
                    '{}': {
                      name: 'Data / Reporting',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'changeTransition',
                  direct: {
                    '{}': {
                      name: 'Change / Transition',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'needsReview',
                  direct: {
                    '{}': {
                      name: 'Needs Review',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
